<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <button class="close-button" @click="closeModal">
        <span class="close-icon">×</span>
      </button>
      
      <div class="modal-body">
        <div class="image-section">
          <img 
            :src="imageUrl"
            :alt="name" 
            class="event-image"
          />
        </div>
        
        <div class="content-section">
          <div class="event-time">{{ start_time ? start_time.slice(0, 5) : '--:--' }} - 12:00 HS</div>
          <h2 class="event-title">{{ name }}</h2>
          <div class="event-audience">PÚBLICO: INSTITUCIONAL</div>
          <div class="event-description">
            <p>{{ description }}</p>
          </div>
          <button
            class="btn-registrarse"
            :class="{ 'btn-cancelar': isSubscribed }"
            @click="onSubscribeClick"
          >
            {{ isSubscribed ? 'Cancelar registro' : 'Registrarse' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import config from "@/config";

const props = defineProps({
  isVisible: {
    type: Boolean,
    required: true,
  },
  image: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  start_time: {
    type: String,
    default: "00:00:00",
  },
  description: {
    type: String,
    required: true,
  },
  isSubscribed: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'subscribe-click']);

const imageUrl = computed(() => {
  return `${config.backendUrl}/${props.image}`;
});

/*const formattedDescription = computed(() => {
  return props.description
    ? `<span class="orange-arrow">>></span> ${props.description.replace(/\n/g, "<br>")}`
    : "";
});*/

const closeModal = () => {
  emit('close');
};

const onSubscribeClick = () => {
  emit('subscribe-click');
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 700;
    backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.modal-content {
  background-color: white;
  padding: 0;
  border-radius: 12px;
  max-width: 1200px;
  width: 95%;
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow: hidden;
}

.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
}

.modal-body {
  display: flex;
  height: 100%;
}

.image-section {
  flex: 0 0 50%;
  background: #f8f9fa;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem;
  padding-top: 3rem;
}

.content-section {
  flex: 0 0 50%;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: calc(80vh - 4rem);
}

.content-section::-webkit-scrollbar {
  width: 8px;
}

.content-section::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.content-section::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.content-section::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}




.event-image {
  width: 500px;
  height: auto;
  border-radius: 12px;
  object-fit: cover;
  max-height: 300px;
}

.event-time {
  color: blue;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.event-title {
  color: #000000;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.event-audience {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}

.event-description {
  color: #333;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  flex: 1;
  overflow-y: auto;
}

.event-description p {
  margin: 0;
}

.btn-registrarse {
  background: #021f5b;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  align-self: flex-start;
}

.btn-registrarse:hover {
  background: #1a4a8a;
}

.btn-cancelar {
  background: #dc3545;
}

.btn-cancelar:hover {
  background: #b02a37;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: white;
  border: 2px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 701;
}

.close-button:hover {
  background: #f8f8f8;
  transform: scale(1.1);
  border-color: #007bff;
}

.close-icon {
  font-size: 28px;
  line-height: 1;
  color: #333;
  margin-top: -2px;
  transition: color 0.3s ease;
}

.close-button:hover .close-icon {
  color: #007bff;
}

@media (max-width: 768px) {
  .close-button {
    top: 15px;
    right: 15px;
    width: 35px;
    height: 35px;
  }
  
  .close-icon {
    font-size: 24px;
  }
  
  .modal-content {
    max-width: 98%;
    max-height: 85vh;
  }

  .modal-body {
    flex-direction: column;
  }

  .image-section {
    flex: 0 0 auto;
    padding: 1rem;
    padding-top: 1.5rem;
  }

  .content-section {
    flex: 1;
    padding: 1.5rem;
    max-height: calc(85vh - 8rem);
  }

  .event-title {
    font-size: 1.3rem;
  }

  .event-time {
    font-size: 1rem;
  }

  .event-description {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .close-button {
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
  }
  
  .close-icon {
    font-size: 20px;
  }
  
  .modal-content {
    max-width: 99%;
    max-height: 90vh;
  }

  .content-section {
    padding: 1rem;
    max-height: calc(90vh - 6rem);
  }

  .event-title {
    font-size: 1.2rem;
  }

  .event-time {
    font-size: 0.9rem;
  }

  .event-description {
    font-size: 0.85rem;
  }

  .btn-registrarse {
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
  }
}
</style>